var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
import { EventEmitter, OnInit } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { map } from 'rxjs/operators';
import { MsisdnService } from '../../../shared/msisdn/msisdn.service';
import { Ng1IpInfoService } from '../../../shared/ng1/ng1-ip-info.service';
import { NotificationService } from '../../../shared/notification.service';
import { Router } from '@angular/router';
var CreatorPhoneNumbersComponent = /** @class */ (function () {
    function CreatorPhoneNumbersComponent(fb, msisdnService, router, ng1IpInfoService, notify) {
        this.fb = fb;
        this.msisdnService = msisdnService;
        this.router = router;
        this.ng1IpInfoService = ng1IpInfoService;
        this.notify = notify;
        this.numbers = {
            campaignsMsisdns: [],
            mainCallerId: {},
            eeaCallerId: {},
            restricted: false
        };
        this.setRestricted = new EventEmitter();
        this.setMainPhoneNumber = new EventEmitter();
        this.setMainEeaPhoneNumber = new EventEmitter();
        this.changedListPhoneNumbers = new EventEmitter();
    }
    CreatorPhoneNumbersComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.addForm = this.createAddForm();
        this.prepareMsisdnsList().subscribe(function (numbers) {
            _this.setInitPhoneNumbers(numbers);
        });
    };
    CreatorPhoneNumbersComponent.prototype.createAddForm = function () {
        return this.fb.group({
            msisdnId: null
        });
    };
    CreatorPhoneNumbersComponent.prototype.checkMainPhoneNumbers = function () {
        var _this = this;
        this.numbers.campaignsMsisdns = this.numbers.campaignsMsisdns.map(function (number) {
            return __assign({}, number, { mainPhoneNumber: _this.numbers.mainCallerId.id === number.id, mainEeaPhoneNumber: _this.numbers.eeaCallerId.id === number.id });
        });
    };
    CreatorPhoneNumbersComponent.prototype.prepareMsisdnsList = function () {
        var _this = this;
        return (this.msisdns = this.msisdnService
            .msisdns()
            .pipe(map(function (msisdns) {
            return msisdns.filter(function (msisdn) { return !_this.numbers.campaignsMsisdns.find(function (campaignsMsisdn) { return campaignsMsisdn.id === msisdn.id; }); });
        })));
    };
    CreatorPhoneNumbersComponent.prototype.setInitPhoneNumbers = function (numbers) {
        var _this = this;
        var firstEeaPhoneNumber = this.numberId
            ? numbers.find(function (msisdn) { return msisdn.id === Number(_this.numberId); })
            : numbers.find(function (msisdn) { return msisdn.eea; });
        this.onSelectPhoneNumber({ value: firstEeaPhoneNumber });
        this.onSetMainPhoneNumber(firstEeaPhoneNumber);
        this.onSetMainEeaPhoneNumber(firstEeaPhoneNumber);
    };
    CreatorPhoneNumbersComponent.prototype.onSetMainPhoneNumber = function (number) {
        this.numbers.mainCallerId = number;
        this.checkMainPhoneNumbers();
        this.setMainPhoneNumber.next(this.numbers.mainCallerId);
    };
    CreatorPhoneNumbersComponent.prototype.onSetMainEeaPhoneNumber = function (number) {
        this.numbers.eeaCallerId = number;
        this.checkMainPhoneNumbers();
        this.setMainEeaPhoneNumber.next(this.numbers.eeaCallerId);
    };
    CreatorPhoneNumbersComponent.prototype.onSelectPhoneNumber = function (select) {
        this.addForm.get('msisdnId').setValue(null);
        this.numbers.campaignsMsisdns.push(select.value);
        this.changedListPhoneNumbers.next(this.numbers.campaignsMsisdns);
        this.prepareMsisdnsList();
    };
    CreatorPhoneNumbersComponent.prototype.onChangePhoneNumbers = function (restricted) {
        this.numbers.restricted = restricted;
        this.setRestricted.next(restricted);
    };
    CreatorPhoneNumbersComponent.prototype.onRemovePhoneNumber = function (numberId) {
        if (this.numbers.mainCallerId.id === numberId) {
            this.notify.open('PHONE_NUMBERS.CREATOR.MAIN_REQUIRED', {}, this.notify.getDefaultCloseAction());
            return;
        }
        if (this.numbers.eeaCallerId.id === numberId) {
            this.notify.open('PHONE_NUMBERS.CREATOR.EEA_REQUIRED', {}, this.notify.getDefaultCloseAction());
            return;
        }
        this.changedListPhoneNumbers.next(this.numbers.campaignsMsisdns);
        this.numbers.campaignsMsisdns.splice(this.numbers.campaignsMsisdns.findIndex(function (el) { return el.id === numberId; }), 1);
        this.prepareMsisdnsList();
    };
    CreatorPhoneNumbersComponent.prototype.gotoNewNumber = function () {
        var code = this.ng1IpInfoService.getCountry();
        this.router.navigate(['get-new-number', 'pricing', code]);
    };
    return CreatorPhoneNumbersComponent;
}());
export { CreatorPhoneNumbersComponent };
